import { deleteCookie, getCookie } from './cookie';

declare global {
  interface WindowEventMap {
    'cart:discount': CustomEvent<string>;
  }
}

function setDiscountCodeGlobal(discount_code: string): void {
  if (window._EMBARKVET_CURRENTLY_APPLIED_DISCOUNT_CODE !== discount_code) {
    window._EMBARKVET_CURRENTLY_APPLIED_DISCOUNT_CODE = discount_code;
  }
}

function removeDiscountCodeInputs(): void {
  document
    .querySelectorAll('input[type=hidden][name=discount]')
    .forEach((input) => input.remove());
}

export function removeAutoAppliedDiscountIfCookieDiscountIsPresent(): void {
  const discountCode = getCookie('discount_code');
  if (discountCode) {
    removeDiscountCodeInputs();
    setDiscountCodeGlobal(discountCode);
    document.addEventListener('DOMContentLoaded', removeDiscountCodeInputs);
    window.addEventListener('load', removeDiscountCodeInputs);
  }
}

export function removeDiscountCookieIfRemovedByCustomer(): void {
  document.addEventListener('click', function (e) {
    const target = e.target;
    if (!(target instanceof Element)) {
      return;
    }

    if (
      target.matches(
        'form[data-reduction-form] .tag__button, form[data-reduction-form] .tag__button *'
      )
    ) {
      deleteCookie('discount_code');
    }
  });
}

export const removeDiscountCookieOnCheckoutCompletion = (): void => {
  if (!window.Shopify?.Checkout?.page) {
    return;
  }

  if (window.Shopify.Checkout.page !== 'thank_you') {
    return;
  }

  deleteCookie('discount_code');
};
